import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'de_COM',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '200b2e7e-de22-4db5-6f04-58b0f562ec61',
  ''
);
